// Simple i18n dictionary for EN + AR
export const LANGS = { en: "English", ar: "العربية" };

export const dict = {
  en: {
    // Common
    "app.name": "image to pdf + classic cv",
    "common.credits": "credits",
    "common.loading": "Loading…",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.delete": "Delete",
    "common.download": "Download",
    "common.close": "Close",
    "common.back": "Back",

    // Navbar
    "nav.jobMatch": "Job Match",
    "nav.imagePdf": "Image → PDF",
    "nav.cvBuilder": "CV Builder",
    "nav.dashboard": "Dashboard",
    "nav.login": "Login",
    "nav.getStarted": "Get started",
    "nav.logout": "Logout",

    // Landing
    "landing.eyebrow": "PRECISION DOCUMENT SUITE",
    "landing.hero.line1": "Turn images into PDFs.",
    "landing.hero.line2": "Rebuild your CV",
    "landing.hero.line2b": "with classic polish.",
    "landing.hero.desc": "Two tools, one clean workspace. Merge JPGs & PNGs into a single PDF, or drop in your existing résumé and let AI restructure it into a timeless, serif-typeset professional CV.",
    "landing.cta.convert": "Convert images",
    "landing.cta.cv": "Build Classic CV",
    "landing.badge.jwt": "Secure JWT accounts",
    "landing.badge.pricing": "$0.99 for 2 operations",
    "landing.badge.ai": "AI CV extraction",
    "landing.preview.label": "Preview · Classic Template",
    "landing.tool.image.title": "Image → PDF Studio",
    "landing.tool.image.copy": "Drop JPG/PNG/WEBP files, reorder them by drag, and export a single, clean PDF. Great for scans, receipts, and portfolios.",
    "landing.tool.image.tag": "1 credit / conversion",
    "landing.tool.cv.title": "Classic CV",
    "landing.tool.cv.copy": "Upload your existing CV (PDF, DOCX, image). AI extracts every section, you review & edit, and download a beautiful Classic serif PDF.",
    "landing.tool.cv.tag": "1 credit / CV",
    "landing.tool.open": "Open tool",
    "landing.pricing.title": "Simple, honest pricing",
    "landing.pricing.copy": "Pay only when you use it — $0.99 for 2 credits via PayPal. Preview the CV output below before you buy.",
    "landing.pricing.sample": "Preview sample CV",
    "landing.pricing.buy": "Buy credits",
    "landing.pricing.create": "Create account",

    // Auth
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Name (optional)",
    "auth.newPassword": "New password",

    // Login
    "login.title": "Welcome back",
    "login.subtitle": "Log in to continue building professional documents.",
    "login.submit": "Sign in",
    "login.submitting": "Signing in…",
    "login.forgot": "Forgot password?",
    "login.noAccount": "No account?",
    "login.createOne": "Create one",

    // Register
    "register.title": "Create your account",
    "register.subtitle": "Pay only when you use it — $0.99 for 2 operations.",
    "register.sendCode": "Send verification code",
    "register.sending": "Sending code…",
    "register.step2.badge": "STEP 2 · VERIFY EMAIL",
    "register.step2.title": "Check your inbox",
    "register.step2.subtitle": "We sent a 6-digit code to",
    "register.step2.subtitle2": ". It expires in 10 minutes.",
    "register.step2.verify": "Verify & create account",
    "register.step2.verifying": "Verifying…",
    "register.step2.changeEmail": "← Change email",
    "register.step2.resend": "Resend code",
    "register.hasAccount": "Already have an account?",
    "register.signIn": "Sign in",
    "register.devNote": "Dev mode · SendGrid isn't configured. Your code:",

    // Forgot
    "forgot.badge": "RESET PASSWORD",
    "forgot.title": "Forgot your password?",
    "forgot.subtitle": "Enter your email and we'll send a 6-digit verification code.",
    "forgot.send": "Send code",
    "forgot.sending": "Sending…",
    "forgot.back": "Back to sign in",
    "forgot.step2.badge": "STEP 2 · VERIFY & RESET",
    "forgot.step2.title": "Set a new password",
    "forgot.step2.subtitle": "Enter the code sent to",
    "forgot.step2.subtitle2": "and choose a new password.",
    "forgot.step2.submit": "Update password & sign in",
    "forgot.step2.submitting": "Updating…",

    // Dashboard
    "dashboard.badge": "DASHBOARD",
    "dashboard.helloWithName": "Hello, {name}",
    "dashboard.helloDefault": "Your workspace",
    "dashboard.creditsLine": "You have {credits} credits · {ops} operations used",
    "dashboard.savedTitle": "Saved documents",
    "dashboard.savedTotal": "{n} total",
    "dashboard.empty": "Nothing yet. Convert some images or generate a CV to see them here.",
    "dashboard.col.title": "Title",
    "dashboard.col.type": "Type",
    "dashboard.col.created": "Created",
    "dashboard.col.actions": "Actions",
    "dashboard.type.cv": "CV",
    "dashboard.type.image": "Image PDF",
    "dashboard.buy": "Buy credits",

    // Image tool
    "img.badge": "TOOL · IMAGE → PDF",
    "img.title": "Image → PDF Studio",
    "img.subtitle": "Drop images, reorder them, and export a clean single PDF. 1 credit per conversion.",
    "img.dropTitle": "Drop images here or click to browse",
    "img.dropSub": "PNG · JPG · WEBP · up to 30 images",
    "img.reorder": "Reorder · {n} images",
    "img.clear": "Clear all",
    "img.convert": "Convert to PDF",
    "img.converting": "Converting…",
    "img.pdfReady": "PDF READY",
    "img.credits": "Credits remaining: {n}",
    "img.downloadPdf": "Download PDF",

    // CV builder
    "cv.badge": "TOOL · CLASSIC CV",
    "cv.title": "Classic CV",
    "cv.subtitle": "Upload your existing CV → AI extracts → edit → download a Classic PDF. 1 credit per generation.",
    "cv.sample": "Sample CV",
    "cv.uploadTitle": "Upload existing CV (PDF, DOCX, image)",
    "cv.uploadSub": "or start from scratch below",
    "cv.extracting": "Extracting your résumé with AI…",
    "cv.section.personal": "Personal",
    "cv.section.summary": "Summary",
    "cv.section.experience": "Experience",
    "cv.section.education": "Education",
    "cv.section.skills": "Skills",
    "cv.section.languages": "Languages",
    "cv.field.fullName": "Full name",
    "cv.field.jobTitle": "Job title",
    "cv.field.email": "Email",
    "cv.field.phone": "Phone",
    "cv.field.location": "Location",
    "cv.field.website": "Website",
    "cv.field.role": "Role",
    "cv.field.company": "Company",
    "cv.field.start": "Start",
    "cv.field.end": "End",
    "cv.field.institution": "Institution",
    "cv.field.degree": "Degree",
    "cv.field.fieldOfStudy": "Field",
    "cv.add": "Add",
    "cv.bullets": "Bullets",
    "cv.addBullet": "Add bullet",
    "cv.template": "Template",
    "cv.templateClassic": "Classic Serif",
    "cv.tpl.classic": "Classic",
    "cv.tpl.modern": "Modern",
    "cv.tpl.minimal": "Minimal",
    "cv.tpl.dark": "Dark Sidebar",
    "cv.tpl.atsBold": "ATS Bold",
    "cv.tpl.atsClean": "ATS Clean",
    "cv.generate": "Generate & save PDF",
    "cv.generating": "Generating…",
    "cv.livePreview": "Live preview",
    "cv.skillsPh": "Comma-separated: React, Figma, User Research",
    "cv.langsPh": "Comma-separated",

    // Buy credits
    "buy.title": "Top up credits",
    "buy.subtitle": "${price} for every {credits} credits · PayPal",
    "buy.bundle": "Bundle",
    "buy.total": "Total",
    "buy.qty": "Quantity:",
    "buy.notConfigured": "PayPal credentials are not configured on the server yet.",
    "buy.loading": "Loading PayPal…",
    "buy.secure": "Payment is verified server-side before credits are applied.",

    // Toasts
    "toast.welcome": "Welcome back",
    "toast.loginFailed": "Login failed",
    "toast.codeSent": "Verification code sent to {email}",
    "toast.accountCreated": "Account created — top up credits to start",
    "toast.newCodeSent": "New code sent",
    "toast.enter6": "Enter the 6-digit code",
    "toast.pwdShort": "Password must be at least 6 characters",
    "toast.pwdUpdated": "Password updated — you're signed in",
    "toast.emailSent": "If that email exists, a code was sent",
    "toast.pdfReady": "PDF ready",
    "toast.needCredits": "You need credits — top up first",
    "toast.addImages": "Add at least one image",
    "toast.deleted": "Deleted",
    "toast.parsed": "Résumé parsed — review & edit below",
    "toast.cvGenerated": "Classic CV PDF generated",
    "toast.creditsAdded": "+{n} credits added",
    "toast.paypalError": "PayPal error — please try again",

    // Job match
    "job.badge": "AI JOB MATCH",
    "job.title": "Don't just create a CV. Make it fit the job you want.",
    "job.subtitle": "Upload your CV, paste a job description, and let AI show you exactly how well you match — plus rewrite your CV for that specific role, without inventing anything.",
    "job.uploadCv": "Upload your CV",
    "job.uploadHint": "PDF, DOCX, or image · we extract the text",
    "job.jdLabel": "Paste the job description",
    "job.jdPlaceholder": "Paste the full job posting here — responsibilities, requirements, skills, everything the employer wrote…",
    "job.analyzeBtn": "Analyze CV & Job",
    "job.analyzing": "Analyzing…",
    "job.costLine": "Uses 1 credit — only on success.",
    "job.noInvent": "AI never invents skills, dates, or experience you didn't provide.",
    "job.analyzed": "Analysis ready",
    "job.errorNoCredit": "Something went wrong — no credit was used. Please try again.",
    "job.matchScore": "match score",
    "job.targetRole": "TARGET ROLE",
    "job.strengths": "Strengths",
    "job.gaps": "Gaps",
    "job.matched": "Matching keywords",
    "job.missing": "Missing keywords",
    "job.atsNotes": "ATS compatibility analysis",
    "job.atsDisclaimer": "This is a compatibility analysis, not a guarantee of ATS passage.",
    "job.noItems": "No items.",
    "job.improveBtn": "Improve CV with AI",
    "job.improving": "Improving…",
    "job.improved": "Improved version ready — review below",
    "job.beforeAfter": "Before → After",
    "job.beforeAfterHint": "AI rephrased your CV for this role. No new experience, companies, or skills were added.",
    "job.before": "Before",
    "job.after": "After",
    "job.beforeNote": "Your original CV file. Compare the improved version on the right.",
    "job.useImproved": "Use improved version (save PDF)",
    "job.saved": "Saved to your documents",
    "job.savedTitle": "Improved CV saved",
    "job.needCv": "Please upload your CV first",
    "job.jdShort": "Job description is too short — paste the full posting",
    "job.step1Label": "How it works",
    "job.step1": "Upload your existing CV (any format)",
    "job.step2": "Paste the full job description",
    "job.step3": "AI analyzes match + rewrites your CV",
  },

  ar: {
    // Common
    "app.name": "الصور إلى PDF + سيرة كلاسيك",
    "common.credits": "رصيد",
    "common.loading": "جاري التحميل…",
    "common.cancel": "إلغاء",
    "common.confirm": "تأكيد",
    "common.delete": "حذف",
    "common.download": "تنزيل",
    "common.close": "إغلاق",
    "common.back": "رجوع",

    // Navbar
    "nav.jobMatch": "مطابقة الوظيفة",
    "nav.imagePdf": "الصور ← PDF",
    "nav.cvBuilder": "منشئ السيرة",
    "nav.dashboard": "لوحة التحكم",
    "nav.login": "تسجيل الدخول",
    "nav.getStarted": "ابدأ الآن",
    "nav.logout": "خروج",

    // Landing
    "landing.eyebrow": "منظومة مستندات احترافية",
    "landing.hero.line1": "حوّل الصور إلى ملفات PDF.",
    "landing.hero.line2": "أعِد بناء سيرتك الذاتية",
    "landing.hero.line2b": "بلمسة كلاسيكية أنيقة.",
    "landing.hero.desc": "أداتان في مساحة عمل واحدة نظيفة. ادمج صور JPG و PNG في ملف PDF واحد، أو ارفع سيرتك الذاتية وسنعيد صياغتها بذكاء اصطناعي بتصميم كلاسيكي فاخر.",
    "landing.cta.convert": "تحويل الصور",
    "landing.cta.cv": "أنشئ السيرة الكلاسيكية",
    "landing.badge.jwt": "حسابات آمنة (JWT)",
    "landing.badge.pricing": "0.99$ لكل عمليتين",
    "landing.badge.ai": "استخراج السيرة بالذكاء الاصطناعي",
    "landing.preview.label": "معاينة · قالب كلاسيك",
    "landing.tool.image.title": "استوديو الصور ← PDF",
    "landing.tool.image.copy": "ارفع ملفات JPG/PNG/WEBP، أعد ترتيبها بالسحب، وصدّرها كملف PDF واحد نظيف. مثالي للمسحوبات والفواتير والمعرض.",
    "landing.tool.image.tag": "رصيد واحد / تحويل",
    "landing.tool.cv.title": "السيرة الكلاسيكية",
    "landing.tool.cv.copy": "ارفع سيرتك الذاتية (PDF أو DOCX أو صورة). يستخرج الذكاء الاصطناعي كل الأقسام، تراجع وتعدّل، ثم تنزّل PDF كلاسيك أنيق.",
    "landing.tool.cv.tag": "رصيد واحد / سيرة",
    "landing.tool.open": "افتح الأداة",
    "landing.pricing.title": "تسعير بسيط وصادق",
    "landing.pricing.copy": "ادفع فقط عند الاستخدام — 0.99$ مقابل رصيدين عبر PayPal. عاين شكل السيرة قبل أن تشتري.",
    "landing.pricing.sample": "عاين نموذج السيرة",
    "landing.pricing.buy": "شراء رصيد",
    "landing.pricing.create": "أنشئ حساباً",

    // Auth
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.name": "الاسم (اختياري)",
    "auth.newPassword": "كلمة المرور الجديدة",

    // Login
    "login.title": "أهلاً بعودتك",
    "login.subtitle": "سجّل الدخول لمتابعة إنشاء مستنداتك الاحترافية.",
    "login.submit": "تسجيل الدخول",
    "login.submitting": "جاري تسجيل الدخول…",
    "login.forgot": "نسيت كلمة المرور؟",
    "login.noAccount": "لا تملك حساباً؟",
    "login.createOne": "أنشئ واحداً",

    // Register
    "register.title": "أنشئ حسابك",
    "register.subtitle": "ادفع فقط عند الاستخدام — 0.99$ مقابل عمليتين.",
    "register.sendCode": "أرسل رمز التحقق",
    "register.sending": "جاري الإرسال…",
    "register.step2.badge": "الخطوة ٢ · تحقق من البريد",
    "register.step2.title": "افحص بريدك",
    "register.step2.subtitle": "أرسلنا رمزاً من ٦ خانات إلى",
    "register.step2.subtitle2": ". صالح لمدة ١٠ دقائق.",
    "register.step2.verify": "تحقق وأنشئ الحساب",
    "register.step2.verifying": "جاري التحقق…",
    "register.step2.changeEmail": "← تغيير البريد",
    "register.step2.resend": "إعادة الإرسال",
    "register.hasAccount": "لديك حساب؟",
    "register.signIn": "سجّل الدخول",
    "register.devNote": "وضع التطوير · SendGrid غير مفعّل. رمزك:",

    // Forgot
    "forgot.badge": "استعادة كلمة المرور",
    "forgot.title": "نسيت كلمة المرور؟",
    "forgot.subtitle": "أدخل بريدك وسنرسل لك رمز تحقق من ٦ خانات.",
    "forgot.send": "إرسال الرمز",
    "forgot.sending": "جاري الإرسال…",
    "forgot.back": "عودة إلى تسجيل الدخول",
    "forgot.step2.badge": "الخطوة ٢ · تحقق واستعادة",
    "forgot.step2.title": "اختر كلمة مرور جديدة",
    "forgot.step2.subtitle": "أدخل الرمز المرسل إلى",
    "forgot.step2.subtitle2": "واختر كلمة مرور جديدة.",
    "forgot.step2.submit": "تحديث كلمة المرور والدخول",
    "forgot.step2.submitting": "جاري التحديث…",

    // Dashboard
    "dashboard.badge": "لوحة التحكم",
    "dashboard.helloWithName": "أهلاً، {name}",
    "dashboard.helloDefault": "مساحة عملك",
    "dashboard.creditsLine": "لديك {credits} رصيد · {ops} عملية مستخدمة",
    "dashboard.savedTitle": "المستندات المحفوظة",
    "dashboard.savedTotal": "{n} إجمالاً",
    "dashboard.empty": "لا شيء بعد. حوّل بعض الصور أو أنشئ سيرة لتظهر هنا.",
    "dashboard.col.title": "العنوان",
    "dashboard.col.type": "النوع",
    "dashboard.col.created": "تاريخ الإنشاء",
    "dashboard.col.actions": "إجراءات",
    "dashboard.type.cv": "سيرة",
    "dashboard.type.image": "PDF صور",
    "dashboard.buy": "شراء رصيد",

    // Image tool
    "img.badge": "أداة · الصور ← PDF",
    "img.title": "استوديو الصور ← PDF",
    "img.subtitle": "ارفع الصور، أعد ترتيبها، وصدّرها كملف PDF واحد. رصيد واحد لكل عملية.",
    "img.dropTitle": "أفلت الصور هنا أو انقر للتصفح",
    "img.dropSub": "PNG · JPG · WEBP · حتى ٣٠ صورة",
    "img.reorder": "إعادة الترتيب · {n} صورة",
    "img.clear": "مسح الكل",
    "img.convert": "تحويل إلى PDF",
    "img.converting": "جاري التحويل…",
    "img.pdfReady": "PDF جاهز",
    "img.credits": "الرصيد المتبقي: {n}",
    "img.downloadPdf": "تنزيل PDF",

    // CV builder
    "cv.badge": "أداة · السيرة الكلاسيكية",
    "cv.title": "السيرة الكلاسيكية",
    "cv.subtitle": "ارفع سيرتك ← يستخرج الذكاء الاصطناعي البيانات ← عدّل ← نزّل PDF. رصيد واحد لكل توليد.",
    "cv.sample": "نموذج السيرة",
    "cv.uploadTitle": "ارفع سيرة موجودة (PDF أو DOCX أو صورة)",
    "cv.uploadSub": "أو ابدأ من الصفر بالأسفل",
    "cv.extracting": "جاري استخراج سيرتك بالذكاء الاصطناعي…",
    "cv.section.personal": "المعلومات الشخصية",
    "cv.section.summary": "الملخص",
    "cv.section.experience": "الخبرة العملية",
    "cv.section.education": "التعليم",
    "cv.section.skills": "المهارات",
    "cv.section.languages": "اللغات",
    "cv.field.fullName": "الاسم الكامل",
    "cv.field.jobTitle": "المسمى الوظيفي",
    "cv.field.email": "البريد الإلكتروني",
    "cv.field.phone": "الهاتف",
    "cv.field.location": "الموقع",
    "cv.field.website": "الموقع الإلكتروني",
    "cv.field.role": "المنصب",
    "cv.field.company": "الشركة",
    "cv.field.start": "البداية",
    "cv.field.end": "النهاية",
    "cv.field.institution": "المؤسسة",
    "cv.field.degree": "الدرجة",
    "cv.field.fieldOfStudy": "التخصص",
    "cv.add": "إضافة",
    "cv.bullets": "نقاط",
    "cv.addBullet": "إضافة نقطة",
    "cv.template": "القالب",
    "cv.templateClassic": "كلاسيك سيريف",
    "cv.tpl.classic": "كلاسيك",
    "cv.tpl.modern": "عصري",
    "cv.tpl.minimal": "بسيط",
    "cv.tpl.dark": "شريط داكن",
    "cv.tpl.atsBold": "ATS جريء",
    "cv.tpl.atsClean": "ATS نظيف",
    "cv.generate": "توليد وحفظ PDF",
    "cv.generating": "جاري التوليد…",
    "cv.livePreview": "معاينة مباشرة",
    "cv.skillsPh": "افصل بفواصل: React، Figma، أبحاث المستخدم",
    "cv.langsPh": "افصل بفواصل",

    // Buy credits
    "buy.title": "شحن الرصيد",
    "buy.subtitle": "{price}$ مقابل كل {credits} رصيد · PayPal",
    "buy.bundle": "الحزمة",
    "buy.total": "الإجمالي",
    "buy.qty": "الكمية:",
    "buy.notConfigured": "مفاتيح PayPal غير مُعدّة على الخادم بعد.",
    "buy.loading": "جاري تحميل PayPal…",
    "buy.secure": "يتم التحقق من الدفع على الخادم قبل إضافة الرصيد.",

    // Toasts
    "toast.welcome": "أهلاً بعودتك",
    "toast.loginFailed": "فشل تسجيل الدخول",
    "toast.codeSent": "تم إرسال رمز التحقق إلى {email}",
    "toast.accountCreated": "تم إنشاء الحساب — اشحن رصيدك للبدء",
    "toast.newCodeSent": "تم إرسال رمز جديد",
    "toast.enter6": "أدخل الرمز المكوّن من ٦ خانات",
    "toast.pwdShort": "كلمة المرور يجب ألا تقل عن ٦ خانات",
    "toast.pwdUpdated": "تم تحديث كلمة المرور — أنت مسجّل الآن",
    "toast.emailSent": "إذا كان البريد موجوداً، تم إرسال رمز",
    "toast.pdfReady": "PDF جاهز",
    "toast.needCredits": "تحتاج رصيداً — اشحن أولاً",
    "toast.addImages": "أضف صورة واحدة على الأقل",
    "toast.deleted": "تم الحذف",
    "toast.parsed": "تم تحليل السيرة — راجع وعدّل بالأسفل",
    "toast.cvGenerated": "تم توليد PDF السيرة الكلاسيكية",
    "toast.creditsAdded": "تمت إضافة {n} رصيد",
    "toast.paypalError": "خطأ في PayPal — حاول مجدداً",

    // Job match
    "job.badge": "مطابقة الوظيفة بالذكاء الاصطناعي",
    "job.title": "لا تكتب سيرة عادية. اجعلها تناسب الوظيفة اللي بدك ياها.",
    "job.subtitle": "ارفع سيرتك، الصق الوصف الوظيفي، ودع الذكاء الاصطناعي يحسب مدى مطابقتك بالضبط — ثم يعيد صياغة سيرتك للوظيفة بدون أي اختلاق.",
    "job.uploadCv": "ارفع سيرتك الذاتية",
    "job.uploadHint": "PDF أو DOCX أو صورة · نستخرج النص تلقائياً",
    "job.jdLabel": "الصق الوصف الوظيفي",
    "job.jdPlaceholder": "الصق الإعلان الكامل هنا — المهام، المتطلبات، المهارات، كل شيء كتبه صاحب العمل…",
    "job.analyzeBtn": "حلّل السيرة والوظيفة",
    "job.analyzing": "جاري التحليل…",
    "job.costLine": "تستخدم عملية واحدة — فقط عند النجاح.",
    "job.noInvent": "الذكاء الاصطناعي لا يخترع مهارات أو تواريخ أو خبرات لم تذكرها.",
    "job.analyzed": "التحليل جاهز",
    "job.errorNoCredit": "حدث خطأ — لم تُستخدم أي عملية. حاول مجدداً.",
    "job.matchScore": "نسبة المطابقة",
    "job.targetRole": "الوظيفة المستهدفة",
    "job.strengths": "نقاط القوة",
    "job.gaps": "الفجوات",
    "job.matched": "الكلمات المطابقة",
    "job.missing": "الكلمات المفقودة",
    "job.atsNotes": "تحليل توافق ATS",
    "job.atsDisclaimer": "هذا تحليل توافق، وليس ضماناً لاجتياز فلاتر ATS.",
    "job.noItems": "لا يوجد.",
    "job.improveBtn": "حسّن السيرة بالذكاء الاصطناعي",
    "job.improving": "جاري التحسين…",
    "job.improved": "النسخة المحسّنة جاهزة — راجع بالأسفل",
    "job.beforeAfter": "قبل ← بعد",
    "job.beforeAfterHint": "أعاد الذكاء الاصطناعي صياغة سيرتك لهذا الدور. لم يُضف أي خبرة أو شركة أو مهارة جديدة.",
    "job.before": "قبل",
    "job.after": "بعد",
    "job.beforeNote": "سيرتك الأصلية. قارن النسخة المحسّنة على اليمين.",
    "job.useImproved": "استخدم النسخة المحسّنة (احفظ PDF)",
    "job.saved": "تم الحفظ في مستنداتك",
    "job.savedTitle": "تم حفظ السيرة المحسّنة",
    "job.needCv": "ارفع سيرتك أولاً",
    "job.jdShort": "الوصف الوظيفي قصير جداً — الصق الإعلان الكامل",
    "job.step1Label": "كيف يعمل",
    "job.step1": "ارفع سيرتك الذاتية (أي صيغة)",
    "job.step2": "الصق الوصف الوظيفي الكامل",
    "job.step3": "الذكاء الاصطناعي يحلّل ويحسّن سيرتك",
  },
};

export function interpolate(str, vars) {
  if (!vars || !str) return str;
  return String(str).replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
}
